import Send from "../communication";
import { buildQueryParams } from "../utils/dateUtils";

export const getAssistanceEvaluation = async (user = "", scope, scopeType, technicianSelect, currentUser, projectsPeriodFilter) => {
  const queryParams = buildQueryParams(user, false, scopeType, technicianSelect, currentUser, projectsPeriodFilter);
  const query = `/nps/serviceIndicators/evaluation/${scope?.id}`;
  return await Send.get(query, queryParams);
};

export const getDashboardEvaluation = async (user = "", scope, scopeType, technicianSelect, currentUser, projectsPeriodFilter) => {
  const queryParams = buildQueryParams(user, false, scopeType, technicianSelect, currentUser, projectsPeriodFilter);

  const query = `/nps/serviceIndicators/dashboard/${scope?.id}`;
  return await Send.get(query, queryParams);
};

export const getAssistanceEvaluationHistory = async (user = "", scope, scopeType, technicianSelect, currentUser, projectsPeriodFilter) => {
  const queryParams = buildQueryParams(user, false, scopeType, technicianSelect, currentUser, projectsPeriodFilter);

  const query = `/nps/serviceIndicators/history/${scope?.id}`;
  return await Send.get(query, queryParams);
};